import React from 'react'
import { EmbedProps } from 'component-library/publication/Embed/Embed'
import { isOmny, Omny } from 'component-library/publication/Embed/web/Omny'
import { isWayIn, WayIn } from 'component-library/publication/Embed/web/WayIn'
import { isFanHub, FanHub } from 'component-library/publication/Embed/web/FanHub'
import { isCityPulse, CityPulse } from 'component-library/publication/Embed/web/CityPulse'
import {
    LazyShortStack,
    isShortstack,
} from 'component-library/publication/Embed/web/Shortstack.lazy'
import { StyledEmbed } from 'component-library/publication/Embed/Embed.styled'
import {
    is24LiveBlog,
    Blog,
    LIVEBLOG24,
    getLiveBlogIdFromLink,
} from 'component-library/content/Blog/Blog'
import { isSurveyMonkey, SurveyMonkeyJS } from './web/SurveyMonkeyJS'
import { WhistleOut } from './web/WhistleOut'
import { ACast } from './web/ACast'
import { isACast } from './helpers/acast'
import { isWhistleOut } from './helpers/whistleout'
import { Embedly } from './Embedly'
import { isOurLiveBlog, LiveBlog } from '../LiveBlog/LiveBlog'
import { ConfigurationContext } from 'common/context-providers/configuration-context'

export const WebEmbed: React.FC<EmbedProps> = ({ link, log, onEvent, adUnitPath }) => {
    const config = React.useContext(ConfigurationContext)

    if (!link) {
        return null
    }

    if (isACast(link)) {
        return (
            <StyledEmbed className="embed">
                <ACast link={link} />
            </StyledEmbed>
        )
    }

    if (isWhistleOut(link)) {
        return (
            <StyledEmbed className="embed">
                <WhistleOut link={link} />
            </StyledEmbed>
        )
    }

    if (isSurveyMonkey(link)) {
        return (
            <StyledEmbed className="embed">
                <SurveyMonkeyJS link={link} />
            </StyledEmbed>
        )
    }

    // Due to a height bug with embedly (SWM-4308) we are rendering omny in its own iframe
    if (isOmny(link)) {
        return (
            <StyledEmbed className="embed">
                <Omny link={link} />
            </StyledEmbed>
        )
    }

    if (isFanHub(link)) {
        return (
            <StyledEmbed className="embed">
                <FanHub link={link} log={log} />
            </StyledEmbed>
        )
    }

    if (isCityPulse(link)) {
        return (
            <StyledEmbed className="embed">
                <CityPulse link={link} />
            </StyledEmbed>
        )
    }

    if (isShortstack(link)) {
        return (
            <StyledEmbed className="embed">
                <LazyShortStack link={link} />
            </StyledEmbed>
        )
    }

    if (isWayIn(link)) {
        return (
            <StyledEmbed className="embed">
                <WayIn link={link} />
            </StyledEmbed>
        )
    }

    if (is24LiveBlog(link)) {
        const id = getLiveBlogIdFromLink(link)

        if (!id) {
            console.error('24 hour live blog ID could not be found.')
            return <React.Fragment />
        }

        return (
            <StyledEmbed className="embed">
                <Blog blogId={id} provider={LIVEBLOG24} />
            </StyledEmbed>
        )
    }

    if (isOurLiveBlog(link)) {
        if (!config.liveBlogApi || !config.liveBlogSocketUrl) {
            return null
        }

        return (
            <LiveBlog
                blogId={link}
                log={log}
                onEvent={onEvent}
                adUnitPath={adUnitPath}
                liveBlogApi={config.liveBlogApi}
                liveBlogSocketUrl={config.liveBlogSocketUrl}
            />
        )
    }

    return <Embedly link={link} log={log} onEvent={onEvent} adUnitPath={adUnitPath} />
}
export default WebEmbed
